import moment from "moment"
import Link from "next/link"
import { createObjectPagePathname, getMediaUrl } from "@/services/pathname"
import img from "@/assets/img/gallery/gallery-1.jpg"
import 'moment/locale/fr'
import { categories } from "@/services/educationCourse"
import { getName } from "@/services/aroeven"
moment.locale('fr')

type CardProps = {
    educationCourse: EducationCourse
}

export default function Card({
    educationCourse
}: CardProps) {


    const color = {
        wellbeing: 'bienetre',
        citizenship: 'citoyennete'
    }[educationCourse.category] ?? ''

    const target = {
        adults: 'Adultes',
        children: 'Enfants / ados'
    }[educationCourse.target] ?? ''

    return (
        <Link className="vignette -type-1 h-100" href={createObjectPagePathname('EducationCourse', educationCourse)}>
            <div className="vignette__image">
                <div className={"bandeau " + color}>
                    <i className="fi fi-rr-users-class" />
                    Education / formation
                </div>
            </div>
            <div className="vignette__content pt-10">
                <div className="d-flex flex-column justify-content-between h-100">
                    <div>
                        <h4 className="vignette__title py-10">
                            {educationCourse.name}
                        </h4>
                        <div className={"type " + color}>
                            {categories[educationCourse.category]?.name}                            
                        </div>
                        <div className="tarif">
                            {target ? <>Public : {target}</> : <>Tout public</>}
                        </div>
                    </div>
                    <div>
                        <div className="organisation d-flex items-start">
                            <div className="flex-center size-20 rounded-full bg-primary-3 mr-5 text-white">
                                <i className="fi fi-rr-home" />
                            </div>
                            <div className="lh-1 mb-5">Proposé par {getName(educationCourse.proposedBy)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    )
}